import { render } from "./AssistantIcon.vue?vue&type=template&id=55a49294&scoped=true"
import script from "./AssistantIcon.vue?vue&type=script&lang=js"
export * from "./AssistantIcon.vue?vue&type=script&lang=js"

import "./AssistantIcon.vue?vue&type=style&index=0&id=55a49294&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a49294"],['__file',"src/Components/ChatWidget/AssistantAi/Icons/AssistantIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55a49294"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55a49294', __exports__)) {
    api.reload('55a49294', __exports__)
  }
  
  module.hot.accept("./AssistantIcon.vue?vue&type=template&id=55a49294&scoped=true", () => {
    api.rerender('55a49294', render)
  })

}


export default __exports__